// extracted by mini-css-extract-plugin
export default {"root":"ProfileTabNav_root__2cLKR","tabsContainer":"ProfileTabNav_tabsContainer__jhTys","tab":"ProfileTabNav_tab__t7M46"};